//#region Database Tables

export class Advisor{
    constructor(data = {}){
        this.advisor_id = data.advisor_id || null;
        this.broker_id = data.broker_id || null;
        this.tpa_id = data.tpa_id || null;
        this.advisor_firm_name = data.advisor_firm_name || null;
        this.advisor_name = data.advisor_name || null;
        this.advisor_email = data.advisor_email || null;
        this.advisor_address = data.advisor_address || null;
        this.advisor_zip = data.advisor_zip || null;
        this.advisor_city = data.advisor_city || null;
        this.advisor_state = data.advisor_state || null;
        this.is_default = data.is_default || null;
    }
}

export class BrokerDealer{
    constructor(data = {}){
        this.broker_id = data.broker_id || null;
        this.broker_dealer_name = data.broker_dealer_name || null;
        this.firm_address = data.firm_address || null;
        this.firm_zip = data.firm_zip || null;
        this.firm_city = data.firm_city || null;
        this.firm_state = data.firm_state || null;
        this.is_default = data.is_default || null;
    }
}

export class Client{
    constructor(data = {}){
        this.user_id = data.user_id || null;
        this.client_name = data.client_name || null;
        this.client_id = data.client_id || null;
        this.full_legal_company_name = data.full_legal_company_name || null;
        this.company_address = data.company_address || null;
        this.company_city = data.company_city || null;
        this.company_state = data.company_state || null;
        this.company_zip = data.company_zip || null;
        this.company_phone = data.company_phone || null;
        this.company_fax = data.company_fax || null;
        this.company_website = data.company_website || null;
    }
    load(data){
        this.user_id = data.user_id || null;
        this.client_name = data.client_name || null;
        this.client_id = data.client_id || null;
        this.full_legal_company_name = data.full_legal_company_name || null;
        this.company_address = data.company_address || null;
        this.company_city = data.company_city || null;
        this.company_state = data.company_state || null;
        this.company_zip = data.company_zip || null;
        this.company_phone = data.company_phone || null;
        this.company_fax = data.company_fax || null;
        this.company_website = data.company_website || null;
    }
}

export class PBGCRates{
    constructor(data = {}){
        this.plan_years_beginning = data.plan_years_beginning || 0;
        this.se_per_part_rate = data.se_per_part_rate || null;
        this.se_var_rate_per_uvb = data.se_var_rate_per_uvb || null;
        this.se_var_rate_part_cap = data.se_var_rate_part_cap || null;
        this.me_per_part_rate = data.me_per_part_rate || null;
    }
}

export class PlanOpportunity{
    constructor(data = {}){
        this.plan_opportunity_id = data.plan_opportunity_id || null;
        this.client_id = data.client_id || null;
        this.plan_runner_id = data.plan_runner_id || null;
        this.loi_pops_mapping = data.loi_pops_mapping || [];
        this.duration = data.duration || 5;
        this.sales_probability = data.sales_probability || 0;
    }
    load(data){
        this.plan_opportunity_id = data.plan_opportunity_id || null;
        this.client_id = data.client_id || null;
        this.plan_runner_id = data.plan_runner_id || null;
        this.loi_pops_mapping = data.loi_pops_mapping || [];
        this.duration = data.duration || 5;
        this.sales_probability = data.sales_probability || 0;
    }
}

export class PlanType{
    constructor(data = {}){
        this.plan_type_id = data.plan_type_id || null;
        this.parent_type = data.parent_type || null;
        this.sub_type = data.sub_type || null;
        this.is_MEP = data.plan_type_id || false;
        this.is_no_rev_share = data.is_no_rev_share || false;
    }
}

export class Proposal{
    constructor(data = {}){
        this.proposal_id = data.proposal_id || null;
        this.predecessor_id = data.predecessor_id || null;

        this.plan_opportunity_id = data.plan_opportunity_id || null;
        this.client_id = data.client_id || null;
        this.plan_type_id = data.plan_type_id || null;
        this.broker_id = data.broker_id || null;
        this.advisor_id = data.advisor_id || null;
        
        this.rk_id = data.rk_id || null;
        this.wholesaler_id = data.wholesaler_id || null;
        this.template_id = data.template_id || null;
        this.rep_user_id = data.rep_user_id || null;

        this.queue_status =  data.queue_status || null;
    }
}

export class ProposalPricingSection{
    constructor(data = {}){
        this.id = data.id || null;
        this.section_name = data.section_name || null;
        this.custom_groups = data.custom_groups || null;
        this.is_checked = true;
        this.is_shown = true;
        if (typeof(data.is_checked) !== 'undefined'){
            this.is_checked = data.is_checked;
        }
        if (typeof(data.is_shown) !== 'undefined'){
            this.is_shown = data.is_shown;
            if (!this.is_shown) this.is_checked = false;
        }
    }
    superToJson(){
        return {
            'id': this.id,
            'section_name': this.section_name,
            'is_checked': this.is_checked,
            'is_shown': this.is_shown
        }
    }
    detailToJson(detail){
        let val;
        try {
            if (detail.data_type == 'int'){
                if (detail.value === null){
                    val = null;
                } else {
                    val = Number(String(detail.value).replace(/\$|,/g, ''));
                }
            } else {
                val = detail.value;
            }
            return {
                'id': detail.id,
                'value': val,
                'data_type': detail.data_type,
                'detail_name': detail.detail_name,
                'custom_group': detail.custom_group
            }
        } catch {
            console.log('detailToJson ERROR');
            console.log(this.section_name);
            console.log(detail);
        }
    }
}

export class ProposalPricingDefaultOptions{
    constructor(data = {}){
        this.id = data.id || null;
        this.entity_type = data.entity_type || null;
        this.entity_id = data.entity_id || null;
        
        this.section_name = data.section_name || null;
        this.detail_name = data.detail_name || null;
        this.custom_group = data.custom_group || null;
        this.value = data.value || null;

        this.plan_type = data.plan_type || null;
        this.data_type = data.data_type || null;
        this.three_sixteen_tier = data.three_sixteen_tier || null;
    }
}

/**
 * A generic data object used to store the value of a field
 * filled out in the UI. It is the the child of the
 * ProposalPricingSection object.
 */
export class ProposalPricingDetail{
    constructor(data = {}){
        this.id = data.id || null;
        this.detail_name = data.detail_name || null;
        /**
         * Only used for the Custom Additions and Custom Notes sections
         * where the format of the data is the same for all the rows of
         * the form. The custom group is a number 1-3 representing the
         * line it appears on in the UI.
         */
        this.custom_group = data.custom_group || null;
        this.data_type = data.data_type || null;
        this.value = data.value || null;

        this.options = [];

        // used for setting defaults
        this.section_name = null;
        this.plan_type = null;

        this.processValueByDataType();
    }

    processValueByDataType(){
        if (!this.data_type) return;
        switch(this.data_type){
            case 'bool':
                if(this.value === "true" || this.value === "True"){
                    this.value = true;
                } else if (this.value === "false" || this.value === "False"){
                    this.value = false;
                }
                break;
        }
    }
    
    forDefault(sectionName,planType){
        return {
            id: this.id,
            detail_name: this.detail_name,
            custom_group: this.custom_group,
            data_type: this.data_type,
            value: this.value,
            section_name: sectionName,
            plan_type: planType
        }
    }
}

// This is WHOLESALER in all the interfaces and should be in the database too. 
// However, due to a miscommunication, the table name is semantically incorrect
// in the database.
export class RepUser{
    constructor(data ={}){
        this.rep_user_id = data.rep_user_id || null; // required
        this.wholesaler_id = data.wholesaler_id || null; // required
        this.rep_name = data.rep_name || null; // required
        this.rep_email = data.rep_email || null; // required
    }
    toJson(){
        return {
            rep_user_id: this.rep_user_id,
            wholesaler_id: this.wholesaler_id,
            rep_name: this.rep_name,
            rep_email: this.rep_email.toLowerCase(),
        }
    }
}

export class TPA{
    constructor(data = {}){
        this.tpa_id = data.tpa_id || null;
        this.is_active = data.is_active || true;
        this.tpa_name = data.tpa_name || null;
        this.tpa_short_name = data.tpa_short_name || null;
        this.tpa_address = data.tpa_address || null;
        this.tpa_zip = data.tpa_zip || null;
        this.tpa_city= data.tpa_city || null;
        this.tpa_state = data.tpa_state || null;
        this.tpa_primary_email = data.tpa_primary_email || null;
        this.tpa_primary_phone = data.tpa_primary_phone || null;
        this.tpa_primary_contactname = data.tpa_primary_contactname || null;
        this.tpa_website = data.tpa_website || null;
        this.voya_plan = data.voya_plan || null;
        this.default_brokers = data.default_brokers || null;
    }
}

export class User{
    constructor(data = {}){
        this.user_id = data.user_id || null;
        this.tpa_id = data.tpa_id || null;
        this.email = data.email || null;
        this.name = data.name || null;
        this.title = data.title || null;
        this.is_active = data.is_active || true;
        this.is_staff = data.is_staff || null;
        this.date_joined = data.date_joined || null;
    }
    load(data){
        this.user_id = data.user_id || null;
        this.tpa_id = data.tpa_id || null;
        this.email = data.email || null;
        this.name = data.name || null;
        this.title = data.title || null;
        this.is_active = data.is_active || true;
        this.is_staff = data.is_staff || null;
        this.date_joined = data.date_joined || null;
    }
    toJson(){
        return {
            user_id: this.user_id,
            tpa_id: this.tpa_id,
            email: this.email.toLowerCase(),
            name: this.name,
            title: this.title,
            is_active: this.is_active,
            is_staff: this.is_staff,
            date_joined: this.date_joined,
        }
    }
}

// This is PROVIDER in all the interfaces and should be in the database too.
// However, due to a miscommunication, the table name is semantically incorrect
// in the database.
export class Wholesaler{
    constructor(data = {}){
        this.wholesaler_id = data.wholesaler_id || null // required
        this.wholesaler_name = data.wholesaler_name || null; // required
        this.wholesaler_email = data.wholesaler_email || null;
        this.about_terms = data.about_terms || null;
        this.installation_credit_terms = data.installation_credit_terms || null;
        this.ongoing_credit_terms = data.ongoing_credit_terms || null;
    }
}

//#endregion

//#region View Models

export class ProposalViewModel{
    constructor(data = {}){
        this.packet = data.packet || {};
        this.proposal = data.proposal || new Proposal();
        this.plan_type = data.plan_type || new PlanType();
        this.price_form = data.price_form || {};
        this.pricing = data.pricing || {};
    }
}

export class PlanOpportunityViewModel{
    constructor(data = {}){
        this.plan_opportunity = data.plan_opportunity || new PlanOpportunity();
        this.planRunner = data. planRunner || new User();
        this.client = data.client || new Client();
        this.lois = data.lois || [];
        this.used_rks = data.used_rks || [];
    }
}

//#endregion

